var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appBody h5-login bg-white"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center mb-40"},[(_vm.isShow)?_c('router-link',{attrs:{"tag":"img","to":{path: '/'},"src":"/static/img/index/logo.png"}}):_c('p',{staticClass:"mb-0 find-pass-title"},[_vm._v("重置密码")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }